import { render, staticRenderFns } from "./phone-number-column.vue?vue&type=template&id=bdd1d5a2&scoped=true"
import script from "./phone-number-column.vue?vue&type=script&lang=js"
export * from "./phone-number-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd1d5a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdd1d5a2')) {
      api.createRecord('bdd1d5a2', component.options)
    } else {
      api.reload('bdd1d5a2', component.options)
    }
    module.hot.accept("./phone-number-column.vue?vue&type=template&id=bdd1d5a2&scoped=true", function () {
      api.rerender('bdd1d5a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/outgoing-number/phone-number-column.vue"
export default component.exports